export const TID_TABLE_COLUMNS = ["companyName", "updatedTs"] as const;

export const CELL_WIDTH = {
  companyName: "50%",
  updatedTs: "50%",
} as const;
